import { type QuizType } from '../../type';

export const QUIZ_TYPE_LABEL_KEY = {
  multiple: 'build.quizType.multiple',
  subjective: 'build.quizType.subjective',
  ox: 'build.quizType.ox',
  essay: 'build.quizType.essay',
  match: 'common:quizCard.typeBadge.match',
  order: 'common:quizCard.typeBadge.order',
} as const satisfies Record<QuizType, string>;
